import styles from './DraftLabel.module.scss';
import { DraftLabelProps } from './DraftLabel.types';

export function DraftLabel({ text }: DraftLabelProps) {
  return <div className={styles.wrapper}>{text}</div>;
}
